<template>
  <el-row class="pc-header">
    <el-col :span="23">
      <div class="the-header">
        <img :src="robotUrl" :class="{'jinzhong':isJinZhong}"/>
        <span class="title" v-if="!PageTitle">
      <span class="bigger">{{ LogoName[0] }}</span>{{ LogoName[1] }}
    </span>
        <span class="title" v-else>{{ PageTitle }}</span>
      </div>
    </el-col>
    <el-col v-if="showAccessibility" :span="1">
      <div class="accessibility" @click="toggleFont"><i class="ri-wheelchair-line"></i></div>
    </el-col>
  </el-row>

</template>

<script>
import { mapState } from "vuex";

export default {
  name: "the-header",
  mixins: [],
  props: {},
  components: {},
  computed: {
    isJinZhong() {
      return process.env.VUE_APP_PAGE_MODE=='jinZhong-pc'
    },
    ...mapState({
      PageTitle: (state) => state.business.sysConfig.PageTitle,
      LogoName: (state) => state.business.sysConfig.LogoName,
      robotUrl: (state) => state.business.sysConfig.robotUrl,
      showAccessibility: (state) => state.business.sysConfig.showAccessibility,
    }),

  },
  data() {
    return {};
  },
  methods: {
    async toggleFont() {
      await this.$store.dispatch("style/toggleFontSize");
    }
  },
  mounted() {
    console.log(process.env.VUE_APP_PAGE_MODE)
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/css/_var.scss";
.the-header {
  height: $headerHeight;
  color: rgba(69, 125, 255, 1);
  font-size: 32px;
  display: flex;
  align-items: flex-start;
  font-weight: bold;
  img {
    position: relative;
    z-index: 2;
    width: 100px;
  }
  .jinzhong{
    position: relative;
    z-index: 2;
    width: 255px;
  }

  .title {
    display: flex;
    align-items: center;
  }

  .bigger {
    font-size: 38px;
    transform: translateY(3px);
  }
}
@media screen and (max-width: 768px) {
  .pc-header {
    display: none;
    //font-size: 22px;
    //align-items: normal;
    //
    //img {
    //  transform: none;
    //  width: 60px;
    //  height: 60px;
    //}
  }
}
.accessibility {
  height: $headerHeight;
  display: flex;
  color: rgba(69, 125, 255, 1);
  font-size: 32px;
  i {
    align-self: center;
  }
}
</style>
